<template>
  <div>
    <div>
      <h2 class="mb-5">
        What’s your date of birth?
      </h2>
    </div>
    <ValidationObserver ref="dateOfBirth">
      <ValidationProvider v-slot="{ errors }" name="dob" rules="validDate">
        <v-text-field
          type="text"
          placeholder="dd/mm/yyyy"
          v-mask="'##/##/####'"
          :format="inputFormat"
          v-model="dob"
          :error-messages="showValidationErrors ? errors : ''"
          class="mt-2 pt-0"
        />
      </ValidationProvider>
    </ValidationObserver>
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isLoading">
        Continue
      </PrimaryButton>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { formatDate } from "@/utils/time";
import {
  BASE_DATE_FORMAT,
  DATE_FORMAT_WITH_SEPARATOR_REVERSED
} from "@/constants/common";

export default {
  name: "Age",
  components: {
    PrimaryButton,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    userData: Object,
    isLoading: Boolean
  },
  data() {
    return {
      dob: formatDate({
        date: this.userData.dob,
        endFormat: BASE_DATE_FORMAT
      }),
      showValidationErrors: false,
      inputFormat: DATE_FORMAT_WITH_SEPARATOR_REVERSED
    };
  },
  methods: {
    async nextStep() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.dateOfBirth.validate();
      if (isValid) {
        this.$emit("nextStep", {
          data: this.dob && {
            dob: formatDate({
              date: this.dob,
              startFormat: BASE_DATE_FORMAT,
              endFormat: DATE_FORMAT_WITH_SEPARATOR_REVERSED
            })
          },
          dataType: "mainDetails"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
